module.exports = __webpack_public_path__ + "static/media/voltgroom-replacement-blade-2.f6cecd35.png";